import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface ArchitectureEngineeringProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const ArchitectureEngineering: React.FC<ArchitectureEngineeringProps> = ({
    required = false,
    propertyGuid,
    isReview = false,
}) => {
    const [architectureEngineering, set_architectureEngineering] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Site Work']?.['Architecture, Engineering'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Architecture, Engineering': v } } })
    );
    const label = 'Architecture, Engineering';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(architectureEngineering)}
                />
            ) : (
                <MoneyBox
                    id={'architectureEngineering'}
                    allowNegative={false}
                    value={architectureEngineering}
                    onChange={(value) => set_architectureEngineering(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
